module.exports = __webpack_public_path__ + "static/media/Forbes_logo.27d9ad58.png";